import MedicalDocuments from "./MedicalDocuments";
export default MedicalDocuments;
